/**
 * Dense table styling for the O/D Analytics tables.
 *
 * These views carry eight or nine columns, and react-data-table-component gives every
 * column `flex: 0 0 0` with `min-width: 100px` and `flex-shrink: 0` — so a row cannot
 * compress below 100px per column no matter how narrow the card is. The shared table's
 * 24px left padding sits inside that 100px rather than adding to it, and each sortable
 * header reserves a further 18px for the sort arrow even while the arrow is invisible.
 *
 * Trimming the padding to Route Atlas's 10px, and declaring a real per-column `minWidth`
 * in each view, is what keeps these tables inside their card. Merged over RDT's own theme,
 * so anything omitted here keeps the library default.
 */
const odTableStyles = {
    /**
     * Let a wide table be wider than its card instead of squeezing every column.
     *
     * RDT's responsive wrapper already carries `overflow-x: auto`, but `.rdt_Table` is
     * `width: 100%`, so rows never exceed the card and there is nothing to scroll — the columns
     * just compress. `max-content` sizes the table to its widest row, which both enables the
     * scroll and keeps the sticky header aligned with the body as it moves; a `width: 100%`
     * header row would otherwise span only the visible slice.
     */
    table: { style: { minWidth: 'max-content' } },
    headCells: {
        style: {
            backgroundColor: '#F9FAFB',
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: '0.75rem',
            lineHeight: '1.125rem',
            padding: '0.8125rem 0.625rem',
        },
    },
    cells: { style: { padding: '0.875rem 0.625rem' } },
    rows: {
        style: {
            backgroundColor: '#FFFFFF',
            borderBottom: '0.0625rem solid #EAECF0',
        },
    },
};

export default odTableStyles;
